import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { ISelectOption, SetSelectOption } from "src/@types/form";

interface Props {
  option: ISelectOption;
  setOption: SetSelectOption;
}

export const SortOption: FC<Props> = ({ option, setOption }) => {
  const { t } = useTranslation();

  const label =
    typeof option.label !== "string" ? t(option.label.i18nKey) : option.label;

  const onClick = () => setOption(option);

  return (
    <li
      className="cursor-pointer px-2 py-4 hover:text-purple-base"
      onClick={onClick}
    >
      {label || option.value}
    </li>
  );
};
